import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getbatchs: option => request('v1/batch/getbatchs', option, true, false), // 查询批次列表
  getbatch: option => request('v1/batch/getbatch' + querystring(option), {}, true, false), // 查询批次
  addbatch: option => request('v1/batch/addbatch', option, true, false), // 新增批次
  updatebatch: option => request('v1/batch/updatebatch', option, true, false), // 修改批次
  deletebatch: option => request('v1/batch/deletebatch' + querystring(option), {}, true, false), //  删除批次
  getsetsegmentinfo: option => request('v1/tag/set/getsetsegmentinfo', option, true, false), // 查询套码段信息
  downloadbatchtags: option => request('v1/batch/downloadbatchtags' + querystring(option), {}, true, false, true), // 下载企业定制码
  updatebatcheicsfromexcel: option => request('v1/batch/updatebatcheicsfromexcel', option, true, true), // 通过文件更新批次设备识别码
  downloadbatcheics: option => request('v1/batch/downloadbatcheics' + querystring(option), {}, true, false, true), // 下载批次设备识别码
  getbatcheics: option => request('v1/batch/getbatcheics', option, true, false), // 查询批次的设备识别码
  getbatchtagscanurl: option => request('v1/batch/getbatchtagscanurl' + querystring(option), {}, true, false), // 下载批次设备识别码
  updatebatcheics: option => request('v1/batch/updatebatcheics', option, true, false), // 查询批次的设备识别码
  getbatchtags: option => request('v1/batch/getbatchtags', option, true, false) // 查询批次的设备识别码
}
